// How a conversation message is read — side, text, time — and the safe time
// format the transcript uses.
//
// EXTRACTED SO THE PANE AND THE ROW CANNOT DISAGREE. These four were module
// consts inside ProjectDetailPage and its twin, passed into
// ConversationDetailPane as props. That was fine while the pane had exactly one
// call site; the slide-over is a second, and a second copy of "which side is
// this message on" is how the same conversation ends up rendered two ways.
//
// The message shape is genuinely variable — the RPC, the legacy table read and
// the repaired transcripts do not agree on key names — which is why these are
// tolerant readers rather than a schema. That tolerance is the reason to have
// one copy of them.

/** Parse anything date-ish, or null. Mirrors the pages' own tryParseDate. */
const tryParseDate = (value) => {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** "2:05 PM", or "" when the timestamp is unusable. Never throws. */
export const formatTimeOnlySafe = (ts) => {
  const d = tryParseDate(ts);
  return d
    ? d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true })
    : "";
};

/**
 * Which side of the transcript a message sits on.
 * Defaults to "left" (the agent) rather than guessing: an unattributed message
 * shown as the guest's puts words in their mouth.
 */
export const getMsgSide = (m) => {
  const s = (m.role || m.sender || m.author || m.source || "").toString().toLowerCase();
  if (/(user|visitor|customer|client|guest|human)/.test(s)) return "right";
  if (/(assistant|agent|bot|system|ai)/.test(s)) return "left";
  if (m.isUser === true) return "right";
  if (m.isUser === false) return "left";
  return "left";
};

/** The message body, whatever key it arrived under. */
export const getMsgText = (m) => {
  const t = m.text ?? m.message ?? m.content ?? m.msg ?? "";
  if (typeof t === "string") return t;
  if (t && typeof t === "object") {
    try { return JSON.stringify(t); } catch { return String(t); }
  }
  return String(t ?? "");
};

/** The message timestamp, whatever key it arrived under. */
export const getMsgTime = (m) => (m ? (m.time || m.timestamp || m.date || m.created_at || null) : null);
